import { axios, organizationIdConfig } from 'configs';
import { TChannel } from './messages';
import { EOrganizationMemberRole } from 'types/enum';

export type TInquiryContact = {
  memberId: number;
  name: string;
  uuid: string;
  role: EOrganizationMemberRole;
  organizationId: number;
  organizationName: string;
  channelId?: string;
  lastMessageTime?: string;
  unreadCount: number;
};

export type AiSuggestionHistory = {
  id: number;
  organizationId: number;
  channelId: string;
  createdByMemberId: number;
  messageTimetoken: string;
  originalMessage: string;
  aiAnswer: string;
  createdDatetime: string;
};

export const getInquiryContacts = async (): Promise<TInquiryContact[]> => {
  const response = await axios.get<TInquiryContact[]>('inquiry-chat/contacts');

  return response.data;
};

export const createOrGetInquiryChannel = async (
  targetMemberId: number,
): Promise<{ channelId: string }> => {
  const response = await axios.post<{ channelId: string }>(
    'inquiry-chat/channels',
    { targetMemberId },
  );

  return response.data;
};

export const getInquiryChannelDetail = async (
  channelId: string,
): Promise<TChannel> => {
  const response = await axios.get<TChannel>(
    `inquiry-chat/channels/${channelId}`,
  );

  return response.data;
};

export const updateInquirySeenTime = async (
  channelId: string,
  organizationId?: number | null,
): Promise<boolean> => {
  const response = await axios.patch<boolean>(
    `inquiry-chat/channels/${channelId}/seen`,
    undefined,
    organizationIdConfig(organizationId),
  );

  return response.data;
};

export const updateInquiryChannelActive = async (
  channelId: string,
  organizationId?: number | null,
): Promise<boolean> => {
  await Promise.all([
    axios.patch(
      `inquiry-chat/channels/${channelId}/sent`,
      undefined,
      organizationIdConfig(organizationId),
    ),
    updateInquirySeenTime(channelId, organizationId),
  ]);

  return true;
};

export const getAiSuggestion = async (params: {
  channelId: string;
  message: string;
  messageTimetoken: string;
}): Promise<{ answer: string; id: number }> => {
  const response = await axios.post<{ answer: string; id: number }>(
    `inquiry-chat/channels/${params.channelId}/ai-suggest`,
    {
      message: params.message,
      messageTimetoken: params.messageTimetoken,
    },
  );

  return response.data;
};

export const getAiSuggestionHistory = async (
  channelId: string,
  messageTimetoken: string,
): Promise<AiSuggestionHistory[]> => {
  const response = await axios.get<AiSuggestionHistory[]>(
    `inquiry-chat/channels/${channelId}/ai-history/${messageTimetoken}`,
  );

  return response.data;
};
